import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';

const row = css`
	font-size: 16px;
	border-radius: 2px;
	margin-bottom: 2px;
	padding: 8px 24px;
	background-color: white;
	display: flex;

	:last-child {
		margin-bottom: 0;
	}

	.label,
	.value {
		flex: 1;
	}

	.label {
		font-weight: 600;
		font-size: inherit;
		text-align: left;
		color: inherit;
		padding: 0;
		line-height: inherit;
	}

	@media (max-width: 800px) {
		flex-direction: column;
	}
`;

const BacsHeaderRow = ({ label, value }) => (
	<div className={row}>
		<span className="label">{label}</span>
		<span className="value">{value}</span>
	</div>
);

BacsHeaderRow.propTypes = {
	/** Text string for the label (heavier font weight) */
	label: PropTypes.string.isRequired,
	/** Text string for the value */
	value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
};

BacsHeaderRow.defaultProps = {};

export default BacsHeaderRow;
